import { Box, IconButton, Stack, Typography } from '@mui/material'
import { EmptyTableState } from 'components/purchase/EmptyTableState'
import { formatTimeStampToDate } from 'hooks/date/formattedTime'
import { useTranslation } from 'react-i18next'
import EastIcon from '@mui/icons-material/East'
import { useNavigate } from 'react-router-dom'
import { ECommitteeEvaluationStatus, ICommitteeEvaluation } from 'types/committee-evaluation';

type Props = {
  committeeEvaluations: ICommitteeEvaluation[]
  status: ECommitteeEvaluationStatus
}

export const CommitteeEvaluationItem = ({
                                          committeeEvaluations,
  status,
}: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  if (committeeEvaluations.length === 0) {
    return <EmptyTableState />
  }

  return (
    <>
      {committeeEvaluations.map((item) => {
        return (
          <Box
            key={item.id}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginBottom: '10px',
              background: '#fff',
              padding: '15px',
            }}
          >
            <Stack>
              <Typography variant="caption" fontWeight="bold">
                {t('contestName')}: {item.tenderName}
              </Typography>
              <Typography variant="caption" fontWeight="bold">
                {t('tender-winner')}: {item.tenderWinnerName}
              </Typography>
            </Stack>
            <Box>
              <Typography variant="caption" fontWeight="bold">
                {t('tender-type')}: {t(`${item.tenderMethod}`)}
              </Typography>
            </Box>
            <Box>
              <Typography variant="caption" fontWeight="bold">
                {t('startDate')}: {formatTimeStampToDate(item.submissionStartTime)}
              </Typography>
            </Box>
            <Box>
              <IconButton
                onClick={() =>
                  navigate(
                    `/portal/procurement-committee/details/${item.tenderId}/${item.id}?status=${status}`
                  )
                }
                aria-label="view committee evaluation details"
                color="primary"
              >
                <EastIcon />
              </IconButton>
            </Box>
          </Box>
        )
      })}
    </>
  )
}
